import { render, staticRenderFns } from "./TemplateMsg.vue?vue&type=template&id=2effd02c"
import script from "./TemplateMsg.vue?vue&type=script&lang=js"
export * from "./TemplateMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports